// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const chatSessionsId = (z.string());
export const chatSessions = z.object({
    id: chatSessionsId,
    operator_id: operatorId,
    title: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const chatSessionsInitializer = z.object({
    id: chatSessionsId.optional(),
    operator_id: operatorId,
    title: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const chatSessionsMutator = z.object({
    id: chatSessionsId.optional(),
    operator_id: operatorId.optional(),
    title: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=ChatSessions.js.map